module.exports = __webpack_public_path__ + "static/img/IMG_20160308_183010.9eee4b9d.jpg";